var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('covenants-list'),_c('v-btn',{attrs:{"dark":"","fixed":"","bottom":"","right":"","fab":"","color":"accent"},on:{"click":_vm.create}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }